import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';
import { DateRange } from 'react-date-range';
import './Modal.scss'
import { useEffect, useState } from 'react';
import { Card, CardContent, DialogActions, FormControl, MenuItem, Select, } from '@mui/material';
import leave from "../../../../assets/leave.svg";
import upload from "../../../../assets/upload.svg"
import LoadingButton from '@mui/lab/LoadingButton';
import AddHomeRoundedIcon from '@mui/icons-material/AddHomeRounded';
import { useNavigate } from 'react-router-dom';
import { useAppSelector, useAppDispatch } from '../../../../store/hooks/hooks';
import PlacementApi from '../../../../store/services/placement';
import { GetRequests, StudentActions } from '../../../../store/StudentAction';
import { BootstrapInput } from '../../../../theme/theme';
import { createNotifictions } from '../../../../utils/helperFunction';
import { addDays, format, isWeekend } from 'date-fns';

const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement<any, any>;
    },
    ref: React.Ref<unknown>,
) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default function LeaveModal() {
    const [open, setOpen] = React.useState(false);
    const [leaveType, setLeaveType] = useState("")
    const placementDetails = useAppSelector((state: any) => state.user.placement)
    const userDetails = useAppSelector((state: any) => state.user.user)
    const approvedLeaveRequests = useAppSelector((state) => state.user.requests.filter((elm: any) => elm.requestCode === "LR" && elm.Status === "1"))
    const [isLoading, setIsLoading] = useState(false)
    const navigate = useNavigate()
    const [error, setError] = useState("")
    const [datesRange, setDatesRange] = React.useState<any>([
        {
            startDate: new Date(),
            endDate: new Date(),
            key: 'selection'
        }
    ]);
    const dispatch = useAppDispatch()
    const handleClickOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };
    const checkCondition = () => {
        return approvedLeaveRequests.filter((elm: any) => {
            return Date.parse(datesRange[0].startDate.toString()).valueOf() >= Date.parse(elm.details.leaveFrom).valueOf() && Date.parse(datesRange[0].endDate.toString()).valueOf() <= Date.parse(elm.details.leaveTo).valueOf()
        }).length !== 0
    }
    const reset = () => {
        setDatesRange([
            {
                startDate: new Date(),
                endDate: null,
                key: 'selection'
            }
        ])
        setLeaveType("")
    }
    const fetcRequests = async () => {
        await dispatch(GetRequests())
    }
    const handleSubmit = async (e: any) => {
        setIsLoading(true)
        e.preventDefault()
        let body = {
            requestCode: "LR",
            Placement_ID: userDetails.result.Placement_ID,
            Status: "0",
            details: {
                dateApplied: new Date(),
                leaveFrom: datesRange[0].startDate,
                leaveTo: datesRange[0].endDate
            }
        }
        PlacementApi.postNewRequest(body).then(res => {
            createNotifictions({
                target: placementDetails.PlacementAdmin,
                message: `New Leave request generated by ${userDetails.result.first_name} ${userDetails.result.last_name} `,
                type: "RQ"
            })
            dispatch(StudentActions.setMessage("Leave Request Generated"))
            setIsLoading(false)
            fetcRequests()
        }).catch((e) => {
            if (e.response.status === 403) {
                navigate('/login')
            }
            setIsLoading(false)
            reset()
            dispatch(StudentActions.setMessage("Request Generation Failed.Try again."))
        })
    }
    useEffect(() => {
        reset()
        handleClose()
    }, [isLoading])
    useEffect(() => {
        if (leaveType.length === 0) {
            setError("*Please select a leave type.")
        }
        else if (datesRange[0].endDate === null) {
            setError("*Please select an end date.")
        }
        else if (approvedLeaveRequests.filter((elm: any) => {
            return Date.parse(datesRange[0].startDate.toString()).valueOf() >= Date.parse(elm.details.leaveFrom).valueOf() && Date.parse(datesRange[0].endDate.toString()).valueOf() <= Date.parse(elm.details.leaveTo).valueOf()
        }).length !== 0) {
            setError("*Please select other dates.Leave request is already approved")
        }
        else {
            setError("")
        }
    }, [datesRange, leaveType])

    const customDayContent = (day: any) => {
        let extraDot = null;
        if (approvedLeaveRequests.filter((elm: any) => {
            return Date.parse(day.toString()).valueOf() >= Date.parse(elm.details.leaveFrom).valueOf() && Date.parse(day.toString()).valueOf() <= Date.parse(elm.details.leaveTo).valueOf()
        }).length > 0) {
            extraDot = (
                <div
                    style={{
                        height: "5px",
                        width: "5px",
                        borderRadius: "100%",
                        background: "orange",
                        position: "absolute",
                        top: 2,
                        right: 2,
                    }}
                />
            )
        }
        return (
            <div>
                {extraDot}
                <span>{format(day, "d")}</span>
            </div>
        )
    }

    return (
        <div>
            <Card className='cardRequest' onClick={handleClickOpen}>
                <CardContent>
                    <div className='align-content-center align-items-center flex flex-column contentMob'>
                        <img src={leave} alt="leaveRequestIcon" className='cardImage'></img>
                        <p className='font-weight-700 m-0'>Leave Request</p>
                    </div>
                </CardContent>
            </Card>
            <Dialog
                open={open}
                TransitionComponent={Transition}
                className='w-100'
                keepMounted
                fullWidth
                maxWidth="md"
                onClose={handleClose}
                aria-describedby="alert-dialog-slide-description"
            >
                <div>
                    <DialogTitle>Leave Request</DialogTitle>

                </div>

                <DialogContent>
                    <form onSubmit={handleSubmit}>
                        <div className='gridContainer'>
                            <div className='flex flex-column'>
                                <div className='flex flex-column m-2'>
                                    <label className='required'>Leave Type</label>
                                    <FormControl size="small">
                                        <Select
                                            labelId="leave-select-label"
                                            id="leave-select-label"
                                            value={leaveType}
                                            label="Age"
                                            input={<BootstrapInput />}
                                            onChange={(e) => {
                                                setLeaveType(e.target.value)
                                            }}
                                        >
                                            <MenuItem value={"Annual Leave"}>Annual Leave</MenuItem>
                                            <MenuItem value={"Sick Leave"}>Sick Leave</MenuItem>
                                            <MenuItem value={"Paid Time Off"}>Paid Time Off</MenuItem>
                                        </Select>
                                    </FormControl>
                                </div>
                                <div className='flex flex-column m-2'>
                                    <label>About</label>
                                    <textarea className='textArea'></textarea>
                                </div>
                                <div className='flex flex-column m-2'>
                                    <label>Attachments</label>
                                    <div className='align-items-md-center flex flex-column justify-content-center m-2 p-2 attachContainer'>
                                        <img src={upload} alt="upload Icon" style={{
                                            height: "80px"
                                        }}></img>
                                        <p className='font-weight-700 m-0'>Upload a file</p>
                                        <p className='subTitle gray-color body-p m-0 '>PNG,JPG,GIF upto 10MB</p>
                                    </div>
                                </div>
                            </div>
                            <div className='flex flex-column m-2'>
                                <div className='flex justify-content-between'>
                                    <label className='required'>Dates</label>
                                    <div className='align-items-center flex mb-1'>
                                        <div
                                            className='mx-2'
                                            style={{
                                                height: "10px",
                                                width: "10px",
                                                borderRadius: "100%",
                                                background: "orange",
                                                // position: "absolute",
                                                top: 2,
                                                right: 2,
                                            }}
                                        />
                                        <p className='gray-color m-0' style={{
                                            fontSize: "12px"
                                        }}>Leave Approved</p>
                                    </div>

                                </div>

                                <DateRange
                                    editableDateInputs={true}
                                    onChange={item =>
                                        setDatesRange([item.selection])}
                                    moveRangeOnFirstSelection={false}
                                    dayContentRenderer={customDayContent}
                                    ranges={datesRange}
                                    minDate={new Date()}
                                    direction="vertical"
                                    scroll={{ enabled: true }}
                                />
                            </div>
                        </div>
                    </form>
                </DialogContent>
                <DialogActions>
                    <div className='flex justify-content-between w-100'>
                    <p className='font-weight-700 m-0 mx-3 text-danger'>{error}</p>
                        <div className='flex'>
                            <Button onClick={handleClose}>Cancel</Button>
                            <LoadingButton
                                loading={isLoading}
                                loadingPosition="start"
                                onClick={handleSubmit}
                                startIcon={<AddHomeRoundedIcon />}
                                variant="contained"
                                disabled={datesRange[0].endDate === null || leaveType.length === 0 || checkCondition()} autoFocus
                            >
                                Request Now
                            </LoadingButton>

                        </div>


                    </div>

                </DialogActions>
            </Dialog>
        </div>
    );
}